import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Container, Eyebrow, PrimaryButton, scrollToId } from "./Primitives";
import { Wordmark } from "./Nav";

export default function Philosophy() {
  return (
    <>
      <section className="fa-sheet relative z-10 -mt-10 bg-panel py-28 text-fg sm:py-40">
        <Container>
          <Eyebrow className="text-tone">Our philosophy</Eyebrow>
          <h2 className="mt-6 max-w-5xl font-display text-4xl font-light leading-[1.04] tracking-[-0.045em] sm:text-6xl lg:text-7xl">
            <span className="block">You don’t need another AI tool.</span>
            <span className="mt-2 block text-subtle">You need AI that works for your business.</span>
          </h2>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-subtle md:text-lg">
            We identify the right approach, and our experts implement it around your goals, workflows, and team.
          </p>
          <PrimaryButton onClick={() => scrollToId("assessment")} className="fa-cta mt-12">
            Start Your AI Assessment <ArrowRight size={16} aria-hidden className="fa-arrow" />
          </PrimaryButton>
        </Container>
      </section>
      <footer className="border-t border-fg/[0.06] bg-canvas py-10">
        <Container className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <Wordmark className="w-[150px]" />
          <div className="flex flex-wrap items-center gap-x-8 gap-y-2">
            <Link to="/careers" data-testid="footer-careers-link" className="fa-link rounded-sm text-[13px] text-fg underline decoration-fg/30 underline-offset-4 hover:decoration-fg">Join our AI team</Link>
            <Link to="/privacy" data-testid="footer-privacy-link" className="fa-link rounded-sm text-[13px] text-subtle underline decoration-fg/20 underline-offset-4 hover:text-fg">Privacy</Link>
            <p className="text-[13px] text-subtle">AI-powered. Expert-built.</p>
          </div>
        </Container>
      </footer>
    </>
  );
}
